// Generated with util/create-component.js
import Header from './Header';

export default Header;
